import gql from 'graphql-tag';

export const GET_EXECUTION_STATUS = gql`
  query GetReceiveStatusByExecutionId($receiveExecutionUuId: String) {
    getReceiveStatusByExecutionId(receiveExecutionUUId: $receiveExecutionUuId) {
      receiveExecutionReadableId
      receiveExecutionStatus
      inventoryReceiveStatus
      externalScannableId
      receiveReferenceId
      receiveSubmissionTime
      receivedBy
      trackingId
      inventoryReceiveStatus
      errorCode
      receivedLineItemExecutionStatusList {
        lineItemExecutionStatus
        referenceLineItemId
        receivedManufacturerPartNumber
        receivedInternalPartNumber
        receivedManufacturer
        receivedMaterialDefinitionId
        orderLineItemId
        orderLineNumber
        externalOrderNumber
        errorCode
        receivedManufacturerPartNumber
        receivedMaterialDefinitionId
        containerizedMaterialStatusList {
          errorCode
          containerId
          containerScannableId
          receiveQuantity
          receivedSerialList {
            externalSerialId
            serialStatus
            siteSpecificSerialId
            errorCode
            serialReceivedStatus
          }
        }
      }
    }
  }
`;
